import { NgModule } from '@angular/core';
import { RouterModule, Route, Routes } from '@angular/router';

import { AuthGuard } from 'app/auth/auth-guard.service';
import { ReleaseUpdateGuard } from 'app/shared/service/release-update-guard.service';

import { ChartViewComponent } from './charts/chart-view/chart-view.component';
import { ChartsGridComponent } from './charts/charts-list/charts-grid/charts-grid.component';
import { ChartsListComponent } from './charts/charts-list/charts-list.component';
import { ChartsRegisterComponent } from './charts/charts-list/charts-register/charts-register.component';
import { AddEditDashboardComponent } from './dashboards/add-edit-dashboard/add-edit-dashboard.component';
import { DashboardsGridComponent } from './dashboards/dashboards-grid/dashboards-grid.component';
import { CompanyDashboardsListComponent } from './dashboards/dashboards-list/company-dashboards-list.component';
import { TeamDashboardsListComponent } from './dashboards/dashboards-list/team-dashboards-list.component';

const chartsRoute: Route = {
  path: 'dashboards/:dashboardId/charts',
  component: ChartsListComponent,
  children: [
    {
      path: 'grid',
      component: ChartsGridComponent,
      children: [
        {
          path: ':chartId',
          component: ChartViewComponent,
        },
      ],
    },
    {
      path: 'register',
      component: ChartsRegisterComponent,
      children: [
        {
          path: ':chartId',
          component: ChartViewComponent,
        },
      ],
    },
    {
      path: '',
      redirectTo: 'grid',
      pathMatch: 'prefix',
    },
  ],
};

const routes: Routes = [
  {
    path: 'teams/:teamId',
    canActivateChild: [AuthGuard, ReleaseUpdateGuard],
    children: [
      {
        path: 'dashboards',
        component: TeamDashboardsListComponent,
        children: [
          {
            path: 'grid',
            component: DashboardsGridComponent,
            children: [
              {
                path: 'new',
                component: AddEditDashboardComponent,
              },
              {
                path: ':dashboardId',
                component: AddEditDashboardComponent,
              },
            ],
          },
          {
            path: '',
            redirectTo: 'grid',
            pathMatch: 'prefix',
          },
        ],
      },
      chartsRoute,
      {
        path: '',
        redirectTo: 'dashboards',
        pathMatch: 'prefix',
      },
    ],
  },
  {
    path: 'companies/:companyId',
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'dashboards',
        component: CompanyDashboardsListComponent,
        children: [
          {
            path: 'grid',
            component: DashboardsGridComponent,
            children: [
              {
                path: 'new',
                component: AddEditDashboardComponent,
              },
              {
                path: ':dashboardId',
                component: AddEditDashboardComponent,
              },
            ],
          },
          {
            path: '',
            redirectTo: 'grid',
            pathMatch: 'prefix',
          },
        ],
      },
      chartsRoute,
      {
        path: '',
        redirectTo: 'dashboards',
        pathMatch: 'prefix',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AnalyticsRoutingModule {}
